// @owners { team: patients-team }
import { createSelector } from 'reselect';
import { getNextAvailableDates } from './getNextAvailableDates';
import { NEXT_AVAILABLE_DATES_REFETCH_THRESHOLD_MS } from '~shared/actions/nextAvailableDates';
import { getAppTime } from '~shared/features/app-time/selectors/getAppTime';

/**
 * Returns a map of known next available dates by id to whether they're fresh.
 */

type NextAvailableDateIDFreshnessMap = Record<string, boolean>;

export const getNextAvailableDateFreshnessByIDMap = createSelector(
  [getNextAvailableDates, getAppTime],
  (nextAvailableDates, appTime) => {
    return Object.entries(nextAvailableDates).reduce<NextAvailableDateIDFreshnessMap>(
      (available, [id, { computedAt }]) => {
        available[id] = appTime - computedAt < NEXT_AVAILABLE_DATES_REFETCH_THRESHOLD_MS;

        return available;
      },
      {},
    );
  },
);
